/**
 * Client accessors for the staff abuse-block surface (backend `AbuseBlockController`,
 * booking-abuse-protection). Every call funnels through `@repo/api-client`'s fetch mutator (bearer token,
 * RFC 9457 `ApiError`). Shapes are declared locally until the OpenAPI-generated models land (`just gen`);
 * field names mirror the controller DTOs exactly. Queries key under the shell's
 * `["venue", venueId, "abuse-blocks"]` convention so `abuse.*` events invalidate them (eventQueryKeyMap).
 */
import { customInstance } from "@repo/api-client";

export type AbuseBlock = {
  id: string;
  venueId: string;
  keyType: "IP" | "PHONE";
  keyValue: string;
  surface: "BOOKING" | "WAITLIST" | "REQUEST";
  reasonCode: string;
  signal: Record<string, unknown>;
  createdAtSec: number;
  expiresAtSec: number;
  cleared: boolean;
};

export type AbuseBlockPageResponse = { items: AbuseBlock[]; nextCursor: string | null };

const base = (venueId: string) => `/api/v1/venues/${encodeURIComponent(venueId)}/abuse-blocks`;

export const abuseApi = {
  /** Active temporary blocks for a venue, newest first (cursor pagination, ADR-0022). */
  list: (venueId: string, signal?: AbortSignal) =>
    customInstance<AbuseBlockPageResponse>(`${base(venueId)}`, { method: "GET", signal }),

  /** Clear a wrongly-flagged block — the next submission passes; audited to the activity log (CP-6). */
  clear: (venueId: string, blockId: string) =>
    customInstance<AbuseBlock>(`${base(venueId)}/${encodeURIComponent(blockId)}/clear`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: "{}",
    }),
};

export function keyLabel(block: AbuseBlock): string {
  return `${block.keyType}: ${block.keyValue}`;
}
